// extracted by mini-css-extract-plugin
export default {"steps":"styles_steps__kORt-","step":"styles_step__tAoU9","title":"styles_title__-iuqS","point":"styles_point__7luJW"};